export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyCQu4bnu_zp86Ij2jX_9Ui9jMe7v0LgM_w",
        authDomain: "schule-allenmoos-hvy4w95azelh.firebaseapp.com",
        databaseURL: "https://schule-allenmoos-hvy4w95azelh.firebaseio.com",
        projectId: "schule-allenmoos-hvy4w95azelh",
        storageBucket: "schule-allenmoos-hvy4w95azelh.appspot.com",
        messagingSenderId: "491749053029",
        appId: "1:491749053029:web:684234b7edb5a63bae2c8c",
        measurementId: "G-B6X5DRQFQW"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts